import Nav from "./nav"
import CustomCarousel from "./custom-carousel"
import copyUrlToClipboard from "./copy_url_to_clipboard"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    CustomCarousel(jQuery)
    window.copyUrlToClipboard=copyUrlToClipboard
})
